// Scoreboard (held key, in game): the room's players, their team and who is
// on a timerun.

import { TEAM_NAMES } from '../../shared/game/mapLogic';
import { bindLabel } from '../../game/binds';
import { game, net, roomPlayers, settings } from '../state';
import { Icon } from './Icon';

export function Scoreboard() {
  const n = net.value;
  const g = game.value;
  const room = n.room;
  const run = g?.runs[0] ?? null;
  if (!room || !g) return null;
  const running = new Map(roomPlayers.value.map((p) => [p.id, p.running]));
  const rows = room.members.map((m) => ({ ...m, running: m.id === n.client?.id ? null : (running.get(m.id) ?? null) }));
  rows.sort((a, b) => a.team - b.team || a.name.localeCompare(b.name));

  return (
    <div class="scoreboard" role="dialog" aria-label="Scoreboard">
      <header class="scoreboard-head">
        <div>
          <div class="eyebrow">{room.official ? 'Official room' : room.private ? 'Private room' : 'Room'}</div>
          <h2 class="scoreboard-title">{room.name}</h2>
        </div>
        <div class="muted">
          {g.map}
          {run && run !== 'default' ? ` · ${run}` : ''} · {room.members.length}/{room.maxPlayers}
        </div>
      </header>
      <table class="scoreboard-table">
        <thead>
          <tr>
            <th>Player</th>
            <th>Team</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} class={r.id === n.client?.id ? 'me' : undefined}>
              <td>
                {r.id === room.ownerId && (
                  <span class="owner-mark" title="Room owner">
                    <Icon name="crown" size={14} />
                  </span>
                )}
                {r.name}
              </td>
              <td class={`team-${r.team ? 'allies' : 'axis'}`}>{TEAM_NAMES[r.team]}</td>
              <td class="muted">{r.spectating ? 'Spectating' : r.running ? `On a run${r.running !== 'default' ? ` (${r.running})` : ''}` : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p class="muted small scoreboard-hint">
        {bindLabel(settings.value.binds, 'spectate')} spectate · {bindLabel(settings.value.binds, 'followNext')} / {bindLabel(settings.value.binds, 'followPrev')} next / previous player · Watch a player from the pause menu
      </p>
    </div>
  );
}
